<template>

  <div v-show=!confirmed>
    <validator name="paymentvalidator" :groups="['paymentgroup']">
      <div class=uk-modal-dialog>
        <a class="uk-modal-close uk-close"></a>
        <ul>
          <li v-for="error in $paymentvalidator.errors">
            <p>{{error.field}}: {{error.message}}</p>
          </li>
        </ul>
        <h3><strong>Please confirm the details below</strong></h3>
        <div class="uk-accordion uk-margin-top" data-uk-accordion>


          <h3 class=uk-accordion-title>Your Details<i class="uk-align-right uk-icon-small uk-icon-caret-down"></i></h3>
          <div class=uk-accordion-content>
            <form class=uk-form data-uk-margin>

              <div class=uk-form-row>
                <label class=uk-form-label>Your Name</label>
                <input v-model=user.name class="uk-form-width-large " placeholder="e.g. John Simba" v-validate:name="{ required: true, message: 'please put your name so that we can be friends :)' }" initial="off" :classes="{ valid: 'uk-form-success', invalid: 'uk-form-danger' }"
                  group="paymentgroup" required>

              </div>

              <div class=uk-form-row>
                <label class=uk-form-label>Email Address</label>
                <div class=uk-form-icon><i class=uk-icon-inbox></i>
                  <input 
                    type=email
                    v-model=user.email 
                    class=uk-form-width-large 
                    placeholder="e.g. you@youremail.com" 
                    v-validate:email="{ required: true, message: 'email requires an @ and a .', pattern: '/^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i' }"
                    initial="off" 
                    :classes="{ valid: 'uk-form-success', invalid: 'uk-form-danger' }" 
                    group="paymentgroup" required>
                </div>

              </div>

              <div class=uk-form-row>
                <label class=uk-form-label>Phone Number</label>
                <div class="uk-form-icon uk-margin-small-top"><i class=uk-icon-phone></i>
                  <input 
                    type=tel 
                    v-model=user.phoneNumber 
                    class=uk-form-width-large 
                    placeholder="e.g. 0712123456" 
                    v-validate:phonenumber="{ required: true, message: 'we will only use your number for good' }" 
                    initial="off" 
                    :classes="{ valid: 'uk-form-success', invalid: 'uk-form-danger' }"
                    group="paymentgroup" required>
                </div>

              </div>
              <div class="uk-form-row uk-width-1-1">
                <p></p>
                <button class="uk-button uk-button-primary uk-button-large uk-align-center" type=button v-if="$paymentvalidator.paymentgroup.valid" v-on:click="confirm()">Pre-Order</button>
              </div>
            </form>
          </div>
          
        </div>
      </div>
    </validator>
  </div>

  <div v-if=confirmed>
    <div class=uk-modal-dialog>
      <a class="uk-modal-close uk-close"></a>
      <div class="uk-align-center uk-text-center">
        <h2>Thanks for your order</h2>
        <i style="color: #87AB61" class="fa fa-check-circle fa-5x"></i><br>
        <h3>A Kuza representative will get back to you soon</h3>
        <h3>For inquiries call Isaac at</h3>
        <h2>+254718411704</h2>
      </div>
    </div>
  </div>



</template>

<script>
  import store from '../store'
  
  var payload = { channel: "#orders", text: "" }

  export default {

    name: 'PaymentModal',

    props: ['totalPrice'],

    data(){
      return {
        user: { 
          name: "", 
          email: "", 
          phoneNumber: "" 
          },

        confirmationCode: "", 
        confirmed: false 
      }
    },

    methods: {
        confirm: function() {
          if (this.$paymentvalidator.paymentgroup.valid && !this.confirmed) {
            store.starterKitOrders.push(
              this.starterKitOrder
            )
            payload.text = "Kit Order\nname: " + this.user.name + 
                           "\nemail: " + this.user.email + 
                           "\nphone number: " + this.user.phoneNumber + 
                           "\namount: " + this.totalPrice
            $.post("https://hooks.slack.com/services/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", JSON.stringify(payload))
            this.confirmed = true
          }
        }
      },

    computed: {
        starterKitOrder() {
          return {
            user: {
              name: this.user.name,
              email: this.user.email,
              phoneNumber: this.user.phoneNumber
            },
            amount: this.totalPrice
          }
        }
      }
  }
</script>



/** WEBPACK FOOTER **
 ** PaymentModal.vue?47bb4df8
 **/